/**
 * 常用图表的 option 预设，沿用旧 components/dashboard/TrendChart.vue、PieChart.vue 的配置。
 * 颜色不写在这里：系列色、文字、轴线都由 EChart 的主题提供。
 */
import type { EChartsCoreOption } from 'echarts/core'

export interface TrendSeries {
  name: string
  data: number[]
}

export interface NamedValue {
  name: string
  value: number
}

/** 多系列折线趋势图：平滑曲线、浅色面积、图例在底部 */
export function buildTrendLineOption(categories: string[], series: TrendSeries[]): EChartsCoreOption {
  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
    legend: { data: series.map((item) => item.name), bottom: 0 },
    // ECharts 6 弃用了 containLabel，这两项与旧版 containLabel: true 等价
    grid: { left: '3%', right: '4%', bottom: '10%', outerBoundsMode: 'same', outerBoundsContain: 'axisLabel' },
    xAxis: { type: 'category', boundaryGap: false, data: categories },
    yAxis: { type: 'value' },
    series: series.map((item) => ({
      name: item.name,
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 6,
      sampling: 'lttb',
      areaStyle: { opacity: 0.15 },
      data: item.data
    }))
  }
}

/** 环形图：图例竖排在右侧，悬停时在中心显示名称 */
export function buildDonutOption(items: NamedValue[]): EChartsCoreOption {
  return {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    legend: { orient: 'vertical', right: '10%', top: 'center', data: items.map((item) => item.name) },
    series: [
      {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['35%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 10, borderWidth: 2 },
        label: { show: false, position: 'center' },
        emphasis: { label: { show: true, fontSize: 20, fontWeight: 'bold' } },
        labelLine: { show: false },
        data: items.map((item) => ({ name: item.name, value: item.value }))
      }
    ]
  }
}
